<template>
  <div class="video_page" ref="video_page">
    <div
      class="video_box"
      ref="video_box"
      @touchstart="touchstart($event)"
      @touchmove="touchmove($event)"
      @touchend="touchend($event)"
    >
      <div v-if="list.length" class="video" ref="video">
        <video
          ref="videoPalyer"
          class="video-player"
          :nativeControls="false"
          preload
          loop
          muted
          :poster="list[curindex].coverimg"
          :src="list[curindex].videourl"
          @click="onVideoClick"
          playsinline
          webkit-playsinline
        ></video>
      </div>
      <div class="video_item" v-for="(item, index) in list">
        <!-- <img class="mark" :src="item.coverimg" alt="" /> -->
        <p class="f16">{{ index }}</p>
        <img :src="item.coverimg" alt="" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'videoDemo',
  data() {
    return {
      list: [],
      touchstartY: '',
      touchmoveY: '',
      touchendY: '',
      positionY: 0,
      curindex: 0,
      isStop: false
    }
  },
  mounted() {
    this.getData()
  },
  watch: {
    curindex: function(newVal, oldVal) {
      if (newVal == this.list.length - 1) {
        this.getData()
      }
    }
  },
  methods: {
    getData: function() {
      var url =
        this.$ajax.getVideoDetailPostList + '?pageno=1&pagesize=10&index=1&type=down&itemid=46'
      this.$customRequestAjax(url).then((res) => {
        if (res.data.code == 200) {
          this.list = this.list.concat(res.data.list)
        }
      })
    },
    onVideoClick: function() {
      this.$refs.videoPalyer.play()
    },
    touchstart: function(e) {
      // console.log('touchstart', e)
      if (this.isStop) {
        e.preventDefault()
      }
      this.$refs.videoPalyer.pause()
      this.touchstartY = e.changedTouches[0].pageY
    },
    touchmove: function(e) {
      // console.log('touchmove', e)
      if (this.isStop) {
        e.preventDefault()
      }
      this.touchmoveY = e.changedTouches[0].pageY
      this.$refs.video_box.style.transform = `translateY(${this.positionY -
        (this.touchstartY - this.touchmoveY)}px)`
      e.preventDefault()
    },
    touchend: function(e) {
      // console.log('touchend', e)
      if (this.isStop) {
        e.preventDefault()
      }
      this.touchendY = e.changedTouches[0].pageY
      this.positionY = this.positionY - (this.touchstartY - this.touchendY)
      console.log(this.positionY)

      const h = this.$refs.video_page.clientHeight
      let p
      const box_h = this.$refs.video_box.clientHeight
      if (this.touchendY < this.touchstartY) {
        if (Math.abs(this.touchendY - this.touchstartY) > 100) {
          p = Math.floor(this.positionY / h)
          // console.log(p)
        } else {
          p = parseInt(this.positionY / h)
          // console.log(p)
        }
      } else {
        if (Math.abs(this.touchendY - this.touchstartY) > 100) {
          p = Math.ceil(this.positionY / h)
          // console.log(p)
        } else {
          p = parseInt(this.positionY / h)
          // console.log(p)
        }
      }
      this.positionY = h * p
      if (this.positionY > 0) {
        this.$refs.video_box.style.transform = `translateY(0px)`
        this.positionY = 0
      } else if (this.positionY < 0 && Math.abs(this.positionY) > box_h - h) {
        this.positionY = -(box_h - h)
      }
      this.$refs.video_box.style.transform = `translateY(${this.positionY}px)`
      this.$refs.video_box.style.transitionProperty = `transform`
      this.$refs.video_box.style.transitionDuration = `0.4s`
      this.$refs.video_box.style.transitionTimingFunction = `ease`
      this.$refs.video_box.style.transitionDelay = `0s`
      this.curindex = Math.abs(this.positionY) / h
      var timer = setTimeout(() => {
        this.$refs.video.style.top = `${Math.abs(this.positionY)}px`
        this.$refs.video_box.style.transitionProperty = `none`
        this.$refs.video_box.style.transitionDuration = `0s`
        this.$refs.video_box.style.transitionTimingFunction = `ease`
        this.$refs.video_box.style.transitionDelay = `0s`
        clearTimeout(timer)
      }, 400)
      if (this.positionY % h == 0) {
        this.isStop = false
      } else {
        this.isStop = true
      }
      this.$nextTick(() => {
        this.$refs.videoPalyer.play()
      })
      console.log(this.curindex)
    }
  }
}
</script>

<style scoped lang="scss">
.video_page {
  height: 100vh;
  overflow: hidden;
  overscroll-behavior-y: contain;
  overscroll-behavior-y: none;
}
.video_box {
  width: 100%;
  position: relative;
  .video {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100vh;
    z-index: 2;
    video {
      width: 100%;
      height: 100vh;
      object-fit: contain;
    }
  }
  .video_item {
    width: 100%;
    height: 100vh;
    /*border: 0.01rem solid pink;*/
    position: relative;
    background-color: #333;
    .mark {
      object-fit: cover;
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      filter: blur(17px);
    }
    p {
      position: absolute;
      left: 0;
      top: 0;
      color: #000;
    }
    img {
      width: 100%;
      height: 100vh;
      object-fit: contain;
      position: relative;
      z-index: 1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/community-beautitysaid/videoDemo.vue